import React from "react";

function PrivateClient() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Private Client</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              High net worth individuals shape up large corporations.  Just like how the legal affairs of a corporation must be provided for, the legal affairs of individuals must be looked after.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default PrivateClient;
